import * as React from 'react';
import {FC} from 'react';
import {GridRowId, GridRowSelectionModel} from '@mui/x-data-grid';
import {Icon} from '@flexe/ui-components';
import {EligibleForLoadShipment} from '../LoadInterfaces';
import {SelectShipmentsTable} from './SelectShipmentsTable';

interface Props {
  data: EligibleForLoadShipment[];
  isLoading: boolean;
  selectedShipmentIds: GridRowId[];
  rowSelectionModel: GridRowSelectionModel;
  proceedToPreview: () => void;
  handleSelectionModelChange: (selectedRows: GridRowSelectionModel) => void;
}

export const SelectShipments: FC<Props> = (props) => {
  const handleProceedToPreview = () => {
    // reset any state values
    props.proceedToPreview();
  };

  return (
    <div>
      <div className="view-wrapper">
        <SelectShipmentsTable
          selectedShipmentIds={props.selectedShipmentIds}
          isLoading={props.isLoading}
          data={props.data}
          handleSelectionModelChange={props.handleSelectionModelChange}
          rowSelectionModel={props.rowSelectionModel}
        />
      </div>
      <div className="btn-wrapper">
        <button type="button" className="btn-primary" onClick={handleProceedToPreview}>
          Preview
          <Icon icon={'arrow-right'} />
        </button>
      </div>
    </div>
  );
};

export default SelectShipments;
